import styled from 'styled-components'

const Button = styled.div`
  padding-top: 22px;
  padding-right: 0;
  padding-bottom: 22px;
  padding-left: 0;
  display: flex;
  width: 68px;utton
  height: 46px;
  justify-content: center;
  background: none;
  color: initial;
  font-weight: initial;
  border: none;
  border-left-width: 1px;
  border-left-style: solid;
  border-left-color: #E1E1E1;
  @media(max-width: 767px) {
    border: none;
  }
  border-radius: none;
  box-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  line-height: initial;
  &:active,
  &:focus,
  &:focus-within,
  &:hover {
    background: initial;
  }
  svg {
    fill: unset;
  }
  cursor: pointer;
`

export default Button
